// The server marks index.html with NODE_ENV, so local servers that serve a
// production build still count as development.
export function isDevelopmentDeployment(document: Document) {
  return (
    document.querySelector<HTMLMetaElement>('meta[name="live-room-environment"]')?.content !==
    "production"
  );
}

export function appUpdateState(clientVersion: unknown, serverVersion: unknown) {
  const client = String(clientVersion || "development").trim();
  const server = String(serverVersion || "").trim();
  const available = Boolean(server && server !== "development" && server !== client);
  return {
    available,
    canApply: available,
  };
}

export async function readDeploymentVersion(fetchVersion: () => Promise<Response>) {
  try {
    const response = await fetchVersion();
    if (!response?.ok) return "";
    const deployment = await response.json();
    return String(deployment?.version || "").trim();
  } catch {
    return "";
  }
}

export function reconnectDelay(planned: boolean, requestedDelay: unknown, attempt: unknown) {
  if (planned) return Math.max(50, Math.min(Number(requestedDelay) || 150, 2000));
  return Math.min(1000 * 2 ** Math.max(0, Number(attempt) || 0), 10_000);
}
